import { render, staticRenderFns } from "./InsertAppointment.vue?vue&type=template&id=bffbc8c4&scoped=true"
import script from "./InsertAppointment.vue?vue&type=script&lang=js"
export * from "./InsertAppointment.vue?vue&type=script&lang=js"
import style0 from "./InsertAppointment.vue?vue&type=style&index=0&id=bffbc8c4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffbc8c4",
  null
  
)

export default component.exports